var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("textarea", {
    directives: [
      {
        name: "model",
        rawName: "v-model",
        value: _vm.localValue,
        expression: "localValue"
      }
    ],
    staticClass:
      "border border-1 px-3 py-3 placeholder-gray-500 text-gray-700 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150",
    class: { "border-red-500": _vm.error, "bg-gray-300": _vm.disabled },
    attrs: {
      disabled: _vm.disabled,
      placeholder: _vm.placeholder,
      maxlength: _vm.maxLength,
      rows: _vm.rows
    },
    domProps: { value: _vm.localValue },
    on: {
      input: function($event) {
        if ($event.target.composing) {
          return
        }
        _vm.localValue = $event.target.value
      }
    }
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5f9a6b60", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5f9a6b60","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Layout/Form/TextArea.vue
// module id = null
// module chunks = 